import React from 'react';

const LoadingSpinner = ({ message = '', size = 64 }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <img 
        src="https://ffbzkwlpbswgbngwvyvp.supabase.co/storage/v1/object/public/assets/logo/favicons/android-chrome-512x512.png" 
        alt="Cargando..."
        className="animate-spin"
        style={{ width: `${size}px`, height: `${size}px` }}
      />
      {message && (
        <p className="text-gray-600 text-center">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
